const Big = ({ children }: { children: React.ReactNode }) => {
  return <h1 className="font-outfit text-white text-[30px]">{children}</h1>;
};

export default Big;
